import { render } from "./HotDeals.vue?vue&type=template&id=92e69a28&scoped=true"
import script from "./HotDeals.vue?vue&type=script&lang=js"
export * from "./HotDeals.vue?vue&type=script&lang=js"

import "./HotDeals.vue?vue&type=style&index=0&id=92e69a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e69a28"]])

export default __exports__